/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";

//i18n
import { withTranslation } from "react-i18next";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { isFunction } from "../../../../../Libs/CustomMethods/customMethods";

import "./AudioRecord.scss";

const AudioRecord = ({ onCancel, onSubmit, isOpen, t }) => {
  const mediaRecorder = useRef(null);
  const sendAudio = useRef(false);
  const chunks = useRef([]);

  const audioElement = useRef(null);
  const increment = useRef(null);

  const [timer, setTimer] = useState(0);
  const [isActive, setIsActive] = useState(false);

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      onHidden: () => isFunction(onCancel) && onCancel(),
    };
    toastr[type](message);
  };

  const handleSubmit = () => {
    sendAudio.current = true;
    stopStream();
  };

  const handleCancel = () => {
    sendAudio.current = false;
    stopStream();
  };

  const startTimer = () => {
    setIsActive(true);
    increment.current = setInterval(() => {
      setTimer((timer) => timer + 1);
    }, 1000);
  };

  const stopTimer = () => {
    setIsActive(false);
    clearInterval(increment.current);
    setTimer(0);
  };

  const formatTime = () => {
    const minutes = `${Math.floor(timer / 60)}`;
    const getSeconds = `0${timer % 60}`.slice(-2);
    const getMinutes = `0${minutes}`.slice(-2);

    return `${getMinutes}:${getSeconds}`;
  };

  const setupStream = (stream) => {
    window.streamReference = stream;
    chunks.current = [];

    mediaRecorder.current = new MediaRecorder(stream);

    mediaRecorder.current.ondataavailable = (e) => {
      chunks.current.push(e.data);
    };

    mediaRecorder.current.onstop = (e) => {
      let blob = new Blob(chunks.current, { type: "audio/ogg" });
      const obj = {
        id: `audio`,
        file: blob,
        file_url: URL.createObjectURL(blob),
      };
      if (sendAudio.current) {
        isFunction(onSubmit) && onSubmit(obj);
      } else {
        isFunction(onCancel) && onCancel();
      }
    };
  };

  const startStream = () => {
    mediaRecorder.current.start();
    startTimer();
  };

  const stopStream = () => {
    if (window?.streamReference) {
      window.streamReference.getAudioTracks().forEach((track) => track.stop());
    }
    stopTimer();
  };

  const resquestAudioAPI = () =>
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        return { success: true, stream: stream };
      })
      .catch((e) => {
        return { error: true, message: e };
      });

  const startRecording = async () => {
    let authorized = await resquestAudioAPI();
    if (authorized?.success && authorized?.stream) {
      setupStream(authorized.stream);
      startStream();
    } else {
      showToast(
        "error",
        t(
          "This page has been blocked from accessing your microphone. Please enable this and reload the page"
        )
      );
    }
  };

  useEffect(() => {
    if (isOpen) {
      startRecording();
    } else {
      clearInterval(increment.current);
    }
  }, [isOpen]);

  useEffect(() => {
    // Just to ensure that the counter has been cleared
    return () => {
      clearInterval(increment.current);
    };
  }, []);

  return (
    <div className="d-flex h-100 align-items-center border rounded">
      <div
        className="d-flex ml-2 justify-content-center pointer"
        onClick={handleCancel}
      >
        <i className="d-flex mdi mdi-close font-size-15" />
      </div>
      {isActive && (
        <div>
          <svg height="10" width="10" className="d-flex ml-2 recorder-dot">
            <circle cx="5" cy="5" r="5" fill="#f46a6a" />
          </svg>
        </div>
      )}

      <div className="d-flex mx-2 justify-content-center align-items-center recorder-time">
        {formatTime()}
      </div>

      <div
        className="d-flex mr-2 justify-content-center pointer"
        onClick={handleSubmit}
      >
        <i className="d-flex mdi mdi-check font-size-15 text-success" />
      </div>

      <audio ref={audioElement}></audio>
    </div>
  );
};
export default withTranslation()(AudioRecord);
